import { AngularFirestore } from '@angular/fire/firestore';
import { AngularFireAuth } from '@angular/fire/auth';
import { Injectable } from '@angular/core';
import * as firebase from 'firebase/app';
@Injectable({
  providedIn: 'root'
})
export class MatchService {

  matches: any[];
  constructor(private db: AngularFirestore, private auth: AngularFireAuth) {

  }

  getUpcomingMatches(selectedGame: string) {
    return this.db.collection<Match>('VCustomRooms',
      ref => ref.where('game', '==', selectedGame)
        .where('status', "==", 'active')
        .limit(5))
      .valueChanges();
  }


}


export interface Match {
  verified: boolean;
  total: number;
  time: Date;
  teamMode: string;
  status: string;
  server: string;
  roompassword: string;
  roomid: string;
  perkill: number;
  participantCount: number;
  maxPlayer: number;
  matchType: string;
  map: string;
  location: string;
  link: string;
  hostid: string;
  hostImage: string;
  host: string;
  game: string;
  firstWinner: number;
  featureImage: string;
  ef: number;
  description: string;
  created: Date;
  admin: boolean;
}

